<p-toast/>

<div class="flex flex-col gap-4 w-full">

  <!-- Cabeçalho -->
  <p-card>
    <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
      <div class="flex items-center gap-3">
        <i class="pi pi-users text-2xl text-[#E41B2E]"></i>
        <span class="header-title-table">Gestão de Usuários</span>
      </div>
      <a routerLink="/admin"
         class="text-sm text-gray-500 dark:text-red-500 hover:text-[#E41B2E] dark:hover:text-red-400
                flex items-center gap-1 transition-colors self-start sm:self-auto">
        <i class="pi pi-arrow-left text-xs"></i> Voltar ao painel
      </a>
    </div>
  </p-card>

  <!-- Filtros + busca -->
  <div class="flex flex-col sm:flex-row sm:items-center gap-3">
    <div class="flex gap-2 flex-wrap">
      @for (tab of [
        {label: 'Todos', value: 'TODOS'},
        {label: 'Pendentes', value: 'PENDENTE'},
        {label: 'Aprovados', value: 'APROVADO'},
        {label: 'Recusados', value: 'RECUSADO'}
      ]; track tab.value) {
        <button
          class="px-4 py-1.5 rounded-full text-sm font-medium border transition-all"
          [ngClass]="{
            'bg-[#E41B2E] text-white border-[#E41B2E]': filtroAtivo === tab.value,
            'bg-white text-gray-600 border-gray-300 hover:border-red-300 dark:bg-black dark:text-gray-300 dark:border-red-900 dark:hover:border-red-600': filtroAtivo !== tab.value
          }"
          (click)="filtrar(tab.value)"
        >
          {{ tab.label }}
          <span class="ml-1 text-xs opacity-70">({{ totalPorStatus(tab.value) }})</span>
        </button>
      }
    </div>

    <div class="sm:ml-auto">
      <p-iconfield>
        <p-inputicon class="pi pi-search"/>
        <input pInputText type="text" placeholder="Buscar usuário..."
               [(ngModel)]="termoBusca" (ngModelChange)="aplicarFiltro()"
               class="text-sm w-full sm:w-64"/>
      </p-iconfield>
    </div>
  </div>

  <!-- Tabela -->
  <div class="bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200 dark:border-red-900 overflow-hidden">

    @if (loading) {
      <div class="p-4 space-y-3">
        @for (i of [1,2,3,4,5]; track i) {
          <p-skeleton height="44px"/>
        }
      </div>
    } @else if (filtrados.length === 0) {
      <div class="py-16 text-center text-gray-400 dark:text-red-900">
        <i class="pi pi-users text-4xl mb-3 block"></i>
        <p>Nenhum usuário encontrado</p>
      </div>
    } @else {
      <table class="w-full text-sm">
        <thead>
          <tr class="border-b border-gray-200 dark:border-red-900 bg-gray-50 dark:bg-black">
            <th class="text-left px-4 py-3 font-semibold text-gray-500 dark:text-red-500 uppercase text-xs tracking-wide">Usuário</th>
            <th class="text-left px-4 py-3 font-semibold text-gray-500 dark:text-red-500 uppercase text-xs tracking-wide hidden md:table-cell">E-mail</th>
            <th class="text-left px-4 py-3 font-semibold text-gray-500 dark:text-red-500 uppercase text-xs tracking-wide">Status</th>
            <th class="text-left px-4 py-3 font-semibold text-gray-500 dark:text-red-500 uppercase text-xs tracking-wide">Perfil</th>
            <th class="text-left px-4 py-3 font-semibold text-gray-500 dark:text-red-500 uppercase text-xs tracking-wide hidden lg:table-cell">Último acesso</th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          @for (usuario of filtrados; track usuario.id) {
            <tr class="border-b border-gray-100 dark:border-red-900/30
                       hover:bg-gray-50 dark:hover:bg-red-950/10 transition-colors">
              <td class="px-4 py-3">
                <div class="font-medium text-gray-800 dark:text-white">{{ usuario.nome || usuario.username }}</div>
                <div class="text-xs text-gray-400 dark:text-red-500">{{ usuario.username }}</div>
              </td>
              <td class="px-4 py-3 text-gray-500 dark:text-gray-400 hidden md:table-cell">
                {{ usuario.email || '—' }}
              </td>
              <td class="px-4 py-3">
                <p-tag [value]="statusLabel(usuario.statusAcesso)"
                       [severity]="statusSeverity(usuario.statusAcesso)"/>
              </td>
              <td class="px-4 py-3">
                <p-tag [value]="perfilLabel(usuario.perfil)"
                       [severity]="perfilSeverity(usuario.perfil)"/>
                @if (usuario.integracaoSei) {
                  <span class="ml-1 inline-flex items-center rounded bg-[#0978be] px-1.5 py-0.5 text-[10px] font-extrabold text-white align-middle"
                        pTooltip="Integração com o SEI liberada" tooltipPosition="top">sei</span>
                }
              </td>
              <td class="px-4 py-3 text-gray-400 dark:text-gray-600 text-xs hidden lg:table-cell">
                {{ usuario.ultimoLogin ? (usuario.ultimoLogin | slice:0:10) : 'Nunca' }}
              </td>
              <td class="px-4 py-3 text-right">
                <button
                  (click)="abrirModal(usuario)"
                  pTooltip="Editar" tooltipPosition="left"
                  class="p-2 rounded-lg text-gray-400 hover:text-[#E41B2E] hover:bg-red-50
                         dark:hover:bg-red-950/20 dark:hover:text-red-400 transition-colors">
                  <i class="pi pi-pencil text-sm"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

</div>

<!-- Modal de edição -->
<p-dialog [(visible)]="modalAberto" [modal]="true" [draggable]="false"
          [style]="{width: '420px'}">
  <ng-template #header>
    <div class="header-title-dialog">Editar Usuário</div>
  </ng-template>

  @if (usuarioEditando) {
    <div class="space-y-5 py-2">
      <div>
        <p class="text-xs text-gray-400 dark:text-red-500 uppercase tracking-wide mb-1">Usuário</p>
        <p class="font-semibold text-gray-800 dark:text-white">{{ usuarioEditando.nome || usuarioEditando.username }}</p>
        <p class="text-sm text-gray-400 dark:text-gray-500">{{ usuarioEditando.username }}</p>
      </div>

      <div>
        <label class="block text-sm font-semibold mb-1">Status de Acesso</label>
        <p-select [(ngModel)]="statusSelecionado" [options]="opcoesStatus"
                  optionLabel="label" optionValue="value" styleClass="w-full"/>
      </div>

      <div>
        <label class="block text-sm font-semibold mb-1">Perfil</label>
        <p-select [(ngModel)]="perfilSelecionado" [options]="opcoesPerfil"
                  optionLabel="label" optionValue="value" styleClass="w-full"/>
        <div class="mt-2 p-3 bg-gray-50 dark:bg-black border border-gray-200 dark:border-red-900 rounded-lg
                    text-xs text-gray-500 dark:text-gray-400 space-y-1">
          @if (perfilSelecionado === 'ADMIN') {
            <p><strong>Administrador:</strong> acesso total ao sistema e ao painel de administração</p>
          } @else if (perfilSelecionado === 'ADV_USER') {
            <p><strong>Avançado:</strong> criar, editar, exportar e importar notificações</p>
          } @else {
            <p><strong>Visualizador:</strong> apenas pesquisar e visualizar notificações</p>
          }
        </div>
      </div>

      <div class="flex items-start gap-3">
        <div class="shrink-0 pt-0.5">
          <p-checkbox [(ngModel)]="integracaoSeiSelecionada" [binary]="true" inputId="integracao-sei"/>
        </div>
        <label for="integracao-sei" class="text-sm cursor-pointer">
          <span class="font-semibold"><i class="pi pi-link text-xs mr-1"></i>Integração com o SEI</span>
          <span class="block text-xs text-gray-500 dark:text-gray-400">
            Deixa o número SEI clicável quando a pessoa está conectada ao SEI (extensão SisNot ↔ SEI do Chrome).
          </span>
        </label>
      </div>
    </div>
  }

  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancelar" styleClass="btn-transparent"
                (onClick)="modalAberto = false" [disabled]="salvando"/>
      <p-button label="Salvar" icon="pi pi-check" styleClass="btn-red"
                (onClick)="salvar()" [loading]="salvando"/>
    </div>
  </ng-template>
</p-dialog>
